import { render, staticRenderFns } from "./Advert.vue?vue&type=template&id=1de18a36&scoped=true&"
import script from "./Advert.vue?vue&type=script&lang=ts&"
export * from "./Advert.vue?vue&type=script&lang=ts&"
import style0 from "./Advert.vue?vue&type=style&index=0&id=1de18a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de18a36",
  null
  
)

component.options.__file = "Advert.vue"
export default component.exports